const r = {
  xs: 16,
  s: 20,
  m: 24,
  l: 28,
  xl: 32,
  xxl: 40
}, c = Object.keys(r), u = "xs", d = 8, a = 32;
function z(e, o, i) {
  const n = parseInt(e, 10), t = n % i === 0;
  return n >= o && t;
}
const g = {
  large: (e) => z(e, a, d),
  regular: (e) => c.includes(e)
};
function S(e) {
  const o = g.large(e);
  return { isValid: o, size: o ? e : a };
}
function f(e) {
  const o = g.regular(e), i = o ? r[e] : r[u];
  return { isValid: o, size: i };
}
const h = (e, o, i, n) => {
  const t = e.endsWith("Large") || e.endsWith("-large");
  let s, l;
  if (i) {
    if ({ isValid: s, size: l } = t ? S(i) : f(i), !s) {
      const p = t ? `Invalid prop "size" value supplied to "${n}". The prop value should be a number equal or greater than ${a} and multiple of ${d}.` : `Invalid prop "size" value supplied to "${n}". The prop value should be one of the following values: ${c.join(", ")}.`;
      console.error(p);
    }
  } else
    l = t ? a : r[u];
  return {
    class: [e, o].filter(Boolean).join(" "),
    width: l,
    height: l
  };
};
export {
  h as g
};
